import { t } from "i18next"
import { z } from "zod"
import { nonEmptyStringRequired, textAreaDefaultMaxLength } from "@/models/common"
import {
  Language,
  Reason,
  TherapyPrescription,
} from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChCreatePsychologicalPsychoTherapyMutation.graphql"

export const PsychologicalPsychotherapySchema = z.object({
  language: z.custom<Exclude<Language, "ENGLISH">>((language) => !!language, {
    message: "common.fieldErrorList.requiredField",
  }),
  therapyPrescription: z.custom<TherapyPrescription>((prescription) => !!prescription, {
    message: "common.fieldErrorList.requiredField",
  }),
  healthcareProviderId: z.string().optional(),
  diagnosisCode: nonEmptyStringRequired,
  reason: z.custom<Reason>(),
  additionalInformation: z
    .string()
    .max(textAreaDefaultMaxLength, { message: t("common.fieldErrorList.characterLimit") })
    .nullable(),
})

export type PsychologicalPsychotherapy = z.infer<typeof PsychologicalPsychotherapySchema>
